export default __webpack_public_path__ + "static/img/ig_contact_1.3d17287.png";